import { createFileRoute } from "@tanstack/react-router"
import { TeaserLanding } from "@/components/TeaserLanding"

export const Route = createFileRoute("/closed-beta")({
  component: TeaserLanding,
})
